import { QuestionMark } from "@phosphor-icons/react";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import HelpSheet from "./help-section";
import { useTheme } from "@/providers/theme-wrapper";
import { UserButton } from "@wacht/tanstack-router";

export function NavUser() {
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();

  const [helpSheetOpen, setHelpSheetOpen] = useState(false);

  return (
    <div>
      <UserButton showName={false} />
      <HelpSheet open={helpSheetOpen} onOpenChange={setHelpSheetOpen} />
    </div>
  );
}
